const config = {
    id: 9,
    name: "拷贝",
    type: 1,
    module_code: "copy_text",
    icon: "icon-tms-split_line",
    font_icon: "&#xe7da;",
    style_type: 1,
    link_type: 0,
    property_data: {
        text: "拷贝",
        copySuccess: "复制成功",
        copyError: "复制失败",
        height: 100,
        bottom: 0,
        icon_url: ""
    }
};

export default config;